import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Checkout2, ErrorPage } from "./pages";
import NewThankyouPage from "./pages/NewThankyouPage";
import { metaPageView } from "./utils/metaPixel";

function MetaPixelPageViews() {
  const location = useLocation();
  useEffect(() => {
    metaPageView();
  }, [location.pathname]);
  return null;
}

const App = () => {
  return (
    <>
      <BrowserRouter>
        <MetaPixelPageViews />
        <Routes>
          <Route path="/" element={<Checkout2 />} />
          <Route path="*" element={<ErrorPage />} />
          <Route path="/ErrorPage" element={<ErrorPage />} />
          <Route path="/thankyou-page" element={<NewThankyouPage />} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default App;
